<template>
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>

    <div class="company_adress">
      <div class="company_adress_tit">
        <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
        <h5>본사</h5>
      </div>
      <!-- 25.02 구글맵 -> 네이버 지도 api로 변경 -->
      <NaverMap :mapKey="1" :latitude="37.567072" :longitude="126.984068" :zoom="17" width="1200px" height="600px" />
      <div class="company_adress_txt">
        <span>A.</span>
        <P>서울특별시 중구 을지로 5길 19 페럼타워 12층, 페럼인프라</P>
        <span>T.</span>
        <P>02 317 1417</P>
      </div>
    </div>

    <ul class="company_adress_frame">
      <li class="company_adress_list">
        <div class="company_adress_tit">
          <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
          <h5>페럼클럽</h5>
        </div>
        <NaverMap :mapKey="2" :latitude="37.2045007" :longitude="127.6853065" width="600px" height="300px" />
        <div class="company_adress_txt">
          <span>A.</span>
          <P>경기도 여주시 점동면 점동로 181</P>
          <span>T.</span>
          <P>031 887 7000</P>
        </div>
      </li>

      <li class="company_adress_list">
        <div class="company_adress_tit">
          <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
          <h5>인천공장</h5>
        </div>
        <NaverMap :mapKey="3" :latitude="37.482635" :longitude="126.639572" width="600px" height="300px" />
        <div class="company_adress_txt">
          <span>A.</span>
          <P>인천광역시 동구 중봉대로 15 동국제강 전산센터</P>
          <span>T.</span>
          <P>032 830 6270</P>
        </div>
      </li>

      <li class="company_adress_list">
        <div class="company_adress_tit">
          <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
          <h5>포항공장</h5>
        </div>
        <NaverMap :mapKey="4" :latitude="35.972975" :longitude="129.371616" width="600px" height="300px" />
        <div class="company_adress_txt">
          <span>A.</span>
          <P>경북 포항시 남구 대송면 철강산단로195 동국제강 사무동 1층</P>
          <span>T.</span>
          <P>054 721 3390</P>
        </div>
      </li>

      <li class="company_adress_list">
        <div class="company_adress_tit">
          <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
          <h5>부산공장</h5>
        </div>
        <NaverMap :mapKey="5" :latitude="35.111597" :longitude="129.073373" width="600px" height="300px" />
        <div class="company_adress_txt">
          <span>A.</span>
          <P>A. 부산광역시 남구 신선로 102 동국제강</P>
          <span>T.</span>
          <P>054 721 3581</P>
        </div>
      </li>

      <li class="company_adress_list">
        <div class="company_adress_tit">
          <img :src="require('./../../assets/img/sub/01/0104_00.png')" />
          <h5>당진공장</h5>
        </div>
        <NaverMap :mapKey="6" :latitude="36.975937" :longitude="126.767237" width="600px" height="300px" />
        <div class="company_adress_txt">
          <span>A.</span>
          <P>충청남도 당진시 송악읍 고대공단1길 25, 동국제강 본관 4층 전산센터</P>
          <span>T.</span>
          <P>041 351 4715</P>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import NaverMap from "./NaverMap.vue";

export default {
  components: {
    NaverMap
  },
  data: () => ({
    message: "NetworkTab.vue"
  }),
  methods: {},
  computed: {},
  mounted() {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/NetworkTab.vue